import axios from "axios";

class TourService {
    static async fetchTourList(i18n, params) {

        try {

            const response = await axios.get(process.env.CLIENT_API_URL + '/client/tours');

            return response.data;

        } catch (e) {
            console.log("fetchTourList error");
            console.log(e);
        }
    }
}

export default TourService;